export let paymentTermListProps = {
    key: 0,
    payment_date: new Date(),
    amount: 0
}

export let itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: {id: 0, sku_code: '', article_name: '', unit_name: ''},
    description: '',
    qty: 1,
    unit_rate: 0,
    discount_amount: 0,
    sub_total: 0,
    tax_percent: 0,
    tax_amount: 0,
    net_total: 0,
    item_edit: 0
}

export let dataProps = {
    id: 0,
    vendor_id: null, 
    store_id: null,
    home_currency_id: 0,
    billing_currency_id: 0,
    exchange_rate: 0,
    purchase_order_id: 0,
    purchase_order_number: '',
    bill_number: '', 
    bill_date: new Date(), 
    sub_total: 0, 
    discount_amount: 0, 
    taxable_total: 0,
    tax_amount: 0,
    reverse_charge_applicable: false,
    gst_type: 0,
    shipping_and_handling: 0,
    tax_percent_on_shipping: 0,
    adjustment: 0,
    net_total: 0,
    total_paid: 0,
    additional_notes: '',
    account_sub_category_id: null,
    zoho_store_id: null,
    
    item_list: [JSON.parse(JSON.stringify(itemListProps))],
    payment_term: [JSON.parse(JSON.stringify(paymentTermListProps))],
    tax_list: []
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryInvoice/properties.js